import ChevronDown from '~/icons/iconography/chevron/up.svg';
import { StyledLinkAnimationText } from '~/shared/styles/Link';
import { List, ListItem, Icon, LinkLevelThree, LinkLevelFour, LinkLevelFive } from './styled';
import { FilteredNodeProps } from './types';
import { FilterProps } from '../../Filters/Filters';
import { DistinctFacetItem } from '~/lib/data-contract/auto-generated/loop54-api-model';

type Props = FilteredNodeProps & {
    item?: DistinctFacetItem;
    facetName?: string;
    facetDisplayName?: string;
    onFilterClick?: (selected: FilterProps, facetName?: string, facetDisplayName?: string) => void;
};

export const NavigationFilterItem = ({
    facetName,
    facetDisplayName,
    filterValue,
    link,
    children,
    linkLevel,
    onFilterClick,
    item,
}: Props) => {
    const LinkLevelComponent = LinkLevel(linkLevel as number);
    const shouldShowChildren =
        (children?.length && filterValue?.selected) || HasSelectedChildren(children);

    return (
        <ListItem isActive={Boolean(filterValue?.selected) && (linkLevel as number) > 1}>
            <LinkLevelComponent
                animation="reverse"
                title={String(link?.title || link?.text || filterValue?.item)}
                isActive={Boolean(filterValue?.selected)}
                fullWidth
                displayFlex={shouldShowChildren}
                multipleElements
                onClick={() =>
                    onFilterClick?.(filterValue as FilterProps, facetName, facetDisplayName)
                }
                onKeyUpCapture={(target) => {
                    if (target.key === 'Enter')
                        onFilterClick?.(filterValue as FilterProps, facetName, facetDisplayName);
                }}
                tabIndex={0}
            >
                <StyledLinkAnimationText>
                    {item?.item}
                    {link?.text} {filterValue?.count && `(${filterValue.count})`}
                </StyledLinkAnimationText>

                {children?.length ? (
                    <Icon isActive={filterValue?.selected || shouldShowChildren}>
                        <ChevronDown />
                    </Icon>
                ) : null}
            </LinkLevelComponent>

            {shouldShowChildren ? (
                <List>
                    {children?.map((item, index) => (
                        <NavigationFilterItem
                            key={`${item.id}-${index}`}
                            onFilterClick={onFilterClick}
                            facetName={facetName}
                            facetDisplayName={facetDisplayName}
                            {...item}
                        />
                    ))}
                </List>
            ) : null}
        </ListItem>
    );
};

function HasSelectedChildren(children?: Pick<FilteredNodeProps, 'children'>[]): boolean {
    return !children
        ? false
        : (children?.findIndex(
              (item) =>
                  (item as FilteredNodeProps).filterValue?.selected ||
                  HasSelectedChildren(item.children),
          ) as number) > -1;
}

function LinkLevel(itemLevel: number) {
    if (itemLevel === 1) {
        return LinkLevelThree;
    }
    if (itemLevel === 2) {
        return LinkLevelFour;
    }
    return LinkLevelFive;
}
